import connect from '../axios/axios.auth';

const functionApi = {
    get: () => {
        return new Promise((resolve) => {
            connect.get(`/salidas`)
            .then((response) => {
              resolve(response);
            })
        })
    },
    listV2: () => {
        return new Promise((resolve) => {
            connect.get(`/salidas/v2/all`)
            .then((response) => {
              resolve(response);
            })
        })
    },
    create: (data) => {
        return new Promise((resolve) => {
            connect.post('/salidas', { data })
            .then((response) => {
                resolve(response);
            })
        })
    },
    update: (data) => {
        return new Promise((resolve) => {
            connect.put('/salidas', { data })
            .then((response) => {
                resolve(response);
            })
        })
    }
}

export default functionApi;